var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  Akun Anda "),_c('b',[_vm._v("belum")]),_vm._v(" terverifikasi. Silakan hubungi ADMIN\n  untuk proses Verifikasi.\n")])
}]

export { render, staticRenderFns }